import axios from 'axios'

function AttivitaChatMessage({ canDelete, isAdmin, isScanteq, Name, Date, Hours, Message, MessageID, onDeleteMessage }) {

    const handleDeleteMessage = async () => {

        const isConfirmed = window.confirm("Sei sicuro di voler eliminare questo commento?");
        if (!isConfirmed) return;

        try {
            const response = await axios.delete('https://scanteq.com/php/comments_attivita.php', {
                data: { commentId: MessageID }
            });
            console.log(response.data);
            onDeleteMessage(Hours);
        } catch (error) {
            console.error("Errore nell'eliminazione del commento:", error);
        }
    };

    return (
        <div className={`ticket_chatmessage_${isScanteq ? "dark" : "light"}`}>
            {isAdmin && canDelete && <div onClick={handleDeleteMessage} className="ticket_chatmessage_delete">X</div>}
            <div className={`ticket_message_header_${isScanteq ? "dark" : "light"}`}>
                <div className="ticket_message_avatar">
                    {Name && Name.charAt(0).toUpperCase()}
                </div>
                <div className="ticket_message_sender">{Name}</div>
                <div className="ticket_message_date">{Date}</div>
                <div className="ticket_message_date">Ore lavorate: {Hours}</div>
            </div>
            {Message && (
                <div
                    className="ticket_message_body"
                    dangerouslySetInnerHTML={{ __html: Message.replace(/\n/g, '<br>') }}
                />
            )}
        </div >
    );
}

export default AttivitaChatMessage;
